<template>
  <!-- Longform Content -->
  <section 
    v-if="longformDocument" 
    class="mtl"
  >
    <Breadcrumbs
      :post-info="postInfo"
      :page-info="pageInfo"
    />
    <div
      class="fixed-title desktop"
      :class="{ 'full-height' : scrollPosition > 400 }"
    >
      <div class="grid-container grid-x">
        <div
          class="medium-5 drawer"
        >
          <TableOfContentsButton
            :longform-document="longformDocument"
            dropdown
          />
        </div>
        <div class="medium-19">
          <div
            class="owner"
            v-html="postInfo.post_title"
          />
          <div
            class="mvn"
            v-html="documentSection.section_number +' '+documentSection.section_title"
          />
        </div>
      </div>
    </div>
    <div class="row mtxl mobile-top-margin ">
      <div class="large-24 columns">
        <div class="longform-content-page">
          <div class="grid-x">
            <div class="medium-5 desktop">
              <TableOfContentsButton :longform-document="longformDocument" />
            </div>
            <div class="medium-19 small-24">
              <SearchTabs
                :post-info="postInfo"
                :document-section="documentSection"
                @searchThisPage="searchPage"
              />
            </div>
          </div>
          <div class="longform-content-container grid-x mtl">
            <div class="medium-5 desktop" />
            <IconSection
              class="mobile"
              :document-title="postInfo.post_title"
            />
            <!-- Desktop -->
            <div class="longform-content medium-14 small-24 desktop">
              <h2
                class="mtn black bg-ghost-gray"
                tabindex="0"
              >
                <span
                  class="prm"
                  v-html="documentSection.section_number"
                />
                <span v-html="documentSection.section_title" />
                <Footnote
                  v-if="documentSection.footnote_copy"
                  :copy="documentSection.footnote_copy"
                  :index="documentSection.footnote_index"
                  :active-footnote-id="activeFootnote"
                  class="primary"
                  @activeFootnote="setFootnote"
                />
              </h2>
              <p
                v-if="documentSection.section_copy"
                v-html="philaLink(documentSection.section_copy)"
              />
              <h4 class="print-only pbl">
                Published on: {{ publishedDate }}
              </h4>
              <div class="longform-loop">
                <div
                  v-for="( section2, index2 ) in documentSection.children"
                  :key="index2"
                  class="longform-loop-content"
                >
                  <h3
                    :id="toLink(section2.section_title)"
                    class="grid-x"
                    tabindex="0"
                  >
                    <div
                      class="medium-3 small-3"
                      v-html="section2.section_number"
                    />
                    <div
                      :id="section2.section_number"
                      class="medium-21 small-21"
                    >
                      <span
                        v-html="section2.section_title"
                      />
                      <Footnote
                        v-if="section2.footnote_copy"
                        :copy="section2.footnote_copy"
                        :index="section2.footnote_index"
                        :active-footnote-id="activeFootnote"
                        @activeFootnote="setFootnote"
                      />
                    </div>
                  </h3>
                  <div class="grid-x mbl">
                    <div class="medium-3 cell">
                      <div class="line desktop" />
                    </div>
                    <div class="medium-21  small-24 cell">
                      <p v-html="philaLink(section2.section_copy)" />
                      <div
                        v-for="( section3, index3 ) in section2.children"
                        :key="index3"
                        class="grid-x"
                      >
                        <h3
                          :id="toLink(section3.section_title)"
                          class="grid-x full-width"
                          tabindex="0"
                        >
                          <div
                            class="medium-3 small-3"
                            v-html="section3.section_number"
                          />
                          <div
                            :id="section3.section_number"
                            class="medium-21 small-21"
                          >
                            <span
                              v-html="section3.section_title"
                            />
                            <Footnote
                              v-if="section3.footnote_copy"
                              :copy="section3.footnote_copy"
                              :index="section3.footnote_index"
                              :active-footnote-id="activeFootnote"
                              @activeFootnote="setFootnote"
                            />
                          </div>
                        </h3>
                        <div class="medium-24 cell">
                          <p v-html="philaLink(section3.section_copy)" />
                          <div
                            v-for="( section4, index4 ) in section3.children"
                            :key="index4"
                            class="grid-x"
                          >
                            <h3
                              :id="toLink(section4.section_title)"
                              class="grid-x full-width"
                              tabindex="0"
                            >
                              <div
                                class="medium-4 small-4"
                                v-html="section4.section_number"
                              />
                              <div
                                :id="section4.section_number"
                                class="medium-20 small-20"
                              >
                                <span
                                  v-html="section4.section_title"
                                />
                                <Footnote
                                  v-if="section4.footnote_copy"
                                  :copy="section4.footnote_copy"
                                  :index="section4.footnote_index"
                                  :active-footnote-id="activeFootnote"
                                  @activeFootnote="setFootnote"
                                />
                              </div>
                            </h3>
                            <div class="medium-24 cell">
                              <p v-html="philaLink(section4.section_copy)" />
                              <div
                                v-for="( section5, index5 ) in section4.children"
                                :key="index5"
                                class="grid-x"
                              >
                                <div
                                  :id="section5.section_number"
                                  class="medium-4 cell"
                                  v-html="section5.section_number"
                                />
                                <div class="medium-20 cell">
                                  <p v-html="philaLink(section5.section_copy)" />
                                  <div
                                    v-for="( section6, index6 ) in section5.children"
                                    :key="index6"
                                    class="grid-x"
                                  >
                                    <div
                                      :id="section6.section_number"
                                      class="medium-4 cell"
                                      v-html="section6.section_number"
                                    />
                                    <div class="medium-20 cell">
                                      <p v-html="philaLink(section6.section_copy)" />
                                      <div
                                        v-for="( section7, index7 ) in section6.children"
                                        :key="index7"
                                        class="grid-x"
                                      >
                                        <div
                                          :id="section7.section_number"
                                          class="medium-4 cell"
                                          v-html="section7.section_number"
                                        />
                                        <div class="medium-20 cell">
                                          <p v-html="philaLink(section7.section_copy)" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Desktop -->
            <!-- Mobile -->
            <div class="longform-content medium-14 small-24 mobile">
              <h2
                class="mtn black bg-ghost-gray"
              >
                <span
                  class="prm"
                  v-html="documentSection.section_number"
                />
                <span v-html="documentSection.section_title" />
                <MobileFootnote
                  v-if="documentSection.footnote_copy"
                  class="mobile-footnote primary"
                  :copy="documentSection.footnote_copy"
                  :index="documentSection.footnote_index"
                />
              </h2>
              <p
                v-if="documentSection.section_copy"
                v-html="philaLink(documentSection.section_copy)"
              />
              <b-collapse 
                v-for="( section2, index2 ) in documentSection.children"
                :id="'mobile-'+section2.section_number"
                :key="index2"
                class="card pbm"
                animation="slide"
                :open="subsection == section2.section_number || pageSearch == true"
              >
                <div
                  slot="trigger"
                  slot-scope="props"
                  class="card-header grid-x dark-ben-franklin"
                  role="button"
                >
                  <span
                    class="small-3 medium-3"
                    v-html="section2.section_number"
                  />
                  <span
                    class="small-17 medium-17"
                    v-html="section2.section_title"
                  />
                  <a class="card-header-icon small-4 medium-4 pan">
                    <b-icon
                      :icon="props.open ? 'minus' : 'plus'"
                    />
                  </a>
                </div>
                <div class="card-content mtl pvn">
                  <div class="grid-x">
                    <MobileFootnote
                      v-if="section2.footnote_copy"
                      class="mobile-footnote secondary"
                      :copy="section2.footnote_copy"
                      :index="section2.footnote_index"
                    />
                    <p v-html="philaLink(section2.section_copy)" />
                    <div
                      v-for="( section3, index3 ) in section2.children"
                      :key="index3"
                      class="grid-x"
                    >
                      <h5
                        :id="'mobile-'+section3.section_number"
                        class="medium-2 cell mtm mbs"
                        v-html="section3.section_number+' '+section3.section_title"
                      />
                      <MobileFootnote
                        v-if="section3.footnote_copy"
                        class="mobile-footnote secondary"
                        :copy="section3.footnote_copy"
                        :index="section3.footnote_index"
                      />
                      <div class="medium-22 cell">
                        <p v-html="philaLink(section3.section_copy)" />
                        <div
                          v-for="( section4, index4 ) in section3.children"
                          :key="index4"
                          class="grid-x"
                        >
                          <h5
                            :id="'mobile-'+section4.section_number"
                            class="medium-3 cell mtm mbs"
                            v-html="section4.section_number+' '+section4.section_title"
                          />
                          <MobileFootnote
                            v-if="section4.footnote_copy"
                            class="mobile-footnote secondary"
                            :copy="section4.footnote_copy"
                            :index="section4.footnote_index"
                          />
                          <div class="medium-21 cell">
                            <p v-html="philaLink(section4.section_copy)" />
                            <div
                              v-for="( section5, index5 ) in section4.children"
                              :key="index5"
                              class="grid-x"
                            >
                              <div
                                :id="'mobile-'+section5.section_number"
                                class="medium-3 cell mtm mbs"
                                v-html="section5.section_number"
                              />
                              <div class="medium-21 cell">
                                <p v-html="philaLink(section5.section_copy)" />
                                <div
                                  v-for="( section6, index6 ) in section5.children"
                                  :key="index6"
                                  class="grid-x"
                                >
                                  <div
                                    :id="'mobile-'+section6.section_number"
                                    class="medium-3 cell mtm mbs"
                                    v-html="section6.section_number"
                                  />
                                  <div class="medium-21 cell">
                                    <p v-html="philaLink(section6.section_copy)" />
                                    <div
                                      v-for="( section7, index7 ) in section6.children"
                                      :key="index7"
                                      class="grid-x"
                                    >
                                      <div
                                        :id="'mobile-'+section7.section_number"
                                        class="medium-3 cell mtm mbs"
                                        v-html="section7.section_number"
                                      />
                                      <div class="medium-21 cell">
                                        <p v-html="philaLink(section7.section_copy)" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
            <!-- /Mobile -->
            <div class="medium-5">
              <IconSection
                class="desktop"
                :document-title="postInfo.post_title"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableOfContentsMobileDrawer
      :longform-document="longformDocument"
      class="mobile mtl"
    />
  </section>
<!-- /Longform Content -->
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import Footnote from '@/components/Footnote.vue';
import IconSection from '@/components/IconSection.vue';
import MobileFootnote from '@/components/MobileFootnote.vue';
import SearchTabs from '@/components/SearchTabs.vue';
import TableOfContentsButton from '@/components/TableOfContentsButton.vue';
import TableOfContentsMobileDrawer from '@/components/TableOfContentsMobileDrawer.vue';
import moment from 'moment';

export default {
  name: 'LongformDocument',
  components: {
    Breadcrumbs,
    Footnote,
    IconSection,
    MobileFootnote,
    SearchTabs,
    TableOfContentsButton,
    TableOfContentsMobileDrawer,
  },
  props: {
    longformDocument: {
      type: Object,
      required: true,
    },
    postInfo: {
      type: Object,
      required: true,
    },
    section: {
      type: [ Number, String ],
      required: true,
    },
    owners: {
      type: Array,
      required: true,
    },
  },
  data: function() {
    return {
      query: null,
      subsectionChange: true,
      pageSearch: false,
      scrollPosition: null,
      dropdownModalStatus: false,
      activeFootnote: null,
    };
  },
  computed: {
    documentSection() {
      let vm = this;
      let tempSection = Object.entries(vm.longformDocument).filter(([ key, section ]) => { // eslint-disable-line no-unused-vars
        return section.section_number === vm.section;
      });
      return tempSection[0][1];
    },
    pageInfo() {
      return this.documentSection.section_title;
    },
    subsection() {
      let splitSubsection = this.$route.query.subsection ? this.$route.query.subsection.split('.') : null;
      if ( splitSubsection && splitSubsection[1]){
        return splitSubsection[0]+'.'+splitSubsection[1];
      }
      return null;
    },
    publishedDate() {
      return moment(this.postInfo.post_date).format('MMMM D, YYYY');
    },
  },
  watch:{
    '$route.query.subsection'() {
      this.subsectionChange = true;
    },
  },
  mounted () {
    let vm = this;
    vm.init();
    window.addEventListener('scroll', this.updateScroll);
    this.$gtag.event('view_item', {
      'event_category': 'longform-content',
      'event_label': this.section,
    });
  },
  updated () {
    let vm = this;
    vm.init();
  },
  methods: {
    async init () {
      let vm = this;
      await vm.parseQuery();
      await vm.scrollToDiv(); 
    },
    searchPage(searchAction) {
      let vm = this;
      vm.pageSearch = searchAction;
    },
    async parseQuery () {
      let vm = this;
      vm.query = vm.$route.hash;
    },
    async scrollToDiv() {
      let vm = this;
      if (vm.subsectionChange == true) {
        let div = vm.$route.query.subsection;
        if ( div ) {
          let focusDiv = document.getElementById(div);
          if (window.getComputedStyle(document.getElementsByClassName('longform-content desktop')[0]).display == "none" ) {
            focusDiv = document.getElementById('mobile-'+div);
          }
          if (focusDiv) {
            let focusDivOffset = focusDiv.offsetTop;
            window.scrollTo({
              top: focusDivOffset,
              behavior: 'smooth',
            });
          } 
        }
        vm.subsectionChange = false;
      }
    },
    toLink ( text) {
      return text.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g,"").split(' ').join('-').toLowerCase();
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    setFootnote( index ) {
      this.activeFootnote = index;
    },
  },
};
</script>